import script from "./DesiredConfirmView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DesiredConfirmView.vue?vue&type=script&lang=ts&setup=true"

import "./DesiredConfirmView.vue?vue&type=style&index=0&id=32db62ba&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32db62ba"]])

export default __exports__